import {
	MentorProduct,
	flagValidationErrorsInMentorProduct
} from "types-and-validators/MentorProduct";

export type SingleSessionPrice = MentorProduct;

export const flagValidationErrorsInSingleSessionPrice = flagValidationErrorsInMentorProduct;
